import {pxToRem} from '../../../utills/pxToRem'
import {fonts} from '../../foundations/fonts'
import colors from '../../foundations/colors'

/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    baseStyle: () => ({
        swatchGroup: {
            flexDirection: 'column'
        },
        swatchesWrapper: {
            flexWrap: 'wrap'
        },
        swatchLabel: {
            marginBottom: pxToRem(10),
            justifyContent: 'space-between'
        },
        sizeGuideButton: {
            fontFamily: fonts.primary,
            color: colors.cav_pdp_dark_gray,
            fontSize: [`${pxToRem(10)}`, `${pxToRem(10)}`, `${pxToRem(12)}`, `${pxToRem(12)}`],
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: 'normal',
            letterSpacing: pxToRem(1),
            textTransform: 'uppercase',
            textDecoration: 'underline',
            height: 'unset'
        },
        swatchLabelText: {
            fontFamily: fonts.primary,
            fontSize: [`${pxToRem(14)}`, `${pxToRem(14)}`, `${pxToRem(16)}`, `${pxToRem(16)}`],
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: 'normal',
            letterSpacing: pxToRem(1)
        },
        swatch: {
            position: 'relative',
            backgroundColor: 'white',
            _focus: {
                outline: 'none',
                boxShadow: 'outline'
            }
        },
        swatchButton: {
            borderColor: 'gray.200',
            _disabled: {
                opacity: 1
            }
        }
    }),
    variants: {
        circle: (props) => ({
            swatch: {
                height: 11,
                width: 11,
                borderRadius: 'full',
                padding: 1,
                cursor: 'pointer',
                marginRight: 2,
                marginLeft: 0,
                marginBottom: 2,
                color: `${props.selected ? 'black' : 'gray.200'}`,
                border: `${props.selected ? '1px' : '0'}`,
                _hover: {
                    borderColor: `${props.selected ? 'black' : 'gray.200'}`,
                    borderWidth: 1,
                    borderStyle: 'solid'
                },
                _active: {
                    background: 'transparent'
                },
                _before: {
                    content: '""',
                    display: `${props.disabled ? 'block' : 'none'}`,
                    position: 'absolute',
                    height: 11,
                    width: '1px',
                    transform: 'rotate(45deg)',
                    backgroundColor: 'black',
                    zIndex: 1
                }
            },
            swatchButton: {
                height: 8,
                borderColor: 'gray.200',
                width: 8,
                overflow: 'hidden',
                borderRadius: 'full',
                minWidth: 'auto',
                opacity: 1,
                _focus: {
                    outline: 'none'
                }
            }
        }),
        square: (props) => ({
            swatch: {
                marginRight: 2,
                backgroundImage: `${
                    props.disabled
                        ? `${
                              props.selected
                                  ? `linear-gradient(to top left, ${colors.cav_pdp_light_gray} calc(50% - 1px), ${colors.cav_pdp_dark_gray}, ${colors.cav_pdp_light_gray} calc(50% + 1px) )`
                                  : `linear-gradient(to top left, ${colors.cav_pdp_light_gray} calc(50% - 1px), ${colors.cav_pdp_dark_gray}, ${colors.cav_pdp_light_gray} calc(50% + 1px) )`
                          } `
                        : ''
                }`,
                borderColor: `${props.selected ? colors.cav_pdp_dark_gray : 'black'}`,
                borderStyle: 'solid',
                borderWidth: 1,
                paddingLeft: 3,
                paddingRight: 3,
                marginBottom: 2,
                _focus: {outline: 'none'},
                _hover: {
                    textDecoration: 'none',
                    borderColor: 'gray.900',
                    color: `${props.disabled ? 'gray.900' : 'white'}`,
                    backgroundColor: 'black'
                },
                _active: {
                    borderColor: 'gray.900'
                },
                backgroundColor: `${
                    props.selected
                        ? props.disabled
                            ? colors.cav_pdp_light_gray
                            : 'black'
                        : 'white'
                }`,
                color: `${props.selected && !props.disabled ? 'white' : 'gray.900'}`
            },
            swatchButton: {}
        })
    },
    parts: [
        'swatch',
        'swatchButton',
        'swatchLabel',
        'sizeGuideButton',
        'swatchLabelText',
        'sizeGuideModalContent',
        'sizeGuideModalHeader',
        'sizeGuideModalBody'
    ]
}
